import React from 'react';
import styled from 'styled-components';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { NgTooltip } from '../NgTooltip/NgTooltip';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.white};
  border: none;
  border-radius: 4px;
  padding: 3px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.textDimmed};
  line-height: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;

  &:hover {
    filter: brightness(0.9);
  }

  svg {
    width: 13px;
    height: 13px;
  }
`;

interface NgAddButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  tooltip?: string;
  remove?: boolean;
}

export const NgAddButton: React.FC<NgAddButtonProps> = ({ onClick, remove, tooltip }) => (
  <NgTooltip title={tooltip ?? (remove ? 'Remove from deck' : 'Add to deck')} placement="top">
    <StyledButton type="button" onClick={onClick}>
      {remove ? <RemoveIcon /> : <AddIcon />}
    </StyledButton>
  </NgTooltip>
);
